export const REMOVE_TAGS_KEYCODES = [
    8, // Backspace
];
